document.addEventListener('DOMContentLoaded', function() {
  const $cardActionComponent = $('.card-action-component');

  if (!$cardActionComponent.length) { return false; }

  const elements = stripe.elements();

  const paymentIntentClientSecret = $('#payment-intent-client-secret').val();
  const successUrl = $('#success-url').val();
  const failureUrl = $('#failure-url').val();

  function handleError(error) {
    alert("Payment failed - please try again with another card. Message from provider:\n" + error.message);
    top.location = failureUrl;
  }

  function handleSuccess(paymentIntent) {
    top.location = successUrl;
  }

  function handleCardAction() {
    stripe
      .confirmCardPayment(paymentIntentClientSecret)
      .then(function(result) {
        if (result.error) {
          handleError(result.error);
        } else {
          handleSuccess(result.paymentIntent);
        }
      });
  }

  $cardActionComponent.on('click', '#card-action', function(e) {
    e.preventDefault();

    handleCardAction();
  });
});
